import { toInt } from "./utils";
var Version = /** @class */ (function () {
    function Version(major, minor, patchLevel) {
        var _this = this;
        if (patchLevel === void 0) { patchLevel = 0; }
        this.major = major;
        this.minor = minor;
        this.patchLevel = patchLevel;
        this.toString = function () { return _this.major + "." + _this.minor + "." + _this.patchLevel; };
    }
    Version.toString = function (v) { return v.major + "." + v.minor + "." + v.patchLevel; };
    Version.fromString = function (s) {
        var _a = s.split("."), major = _a[0], minor = _a[1], patch = _a[2];
        return new Version(toInt(major).orElse(0), toInt(minor).orElse(0), toInt(patch).orElse(0));
    };
    return Version;
}());
export { Version };



//////////////////
// WEBPACK FOOTER
// ./src/data/Version.ts
// module id = 1225
// module chunks = 0